import React from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import { useDeleteTravel } from '@hooks/API/Event/UseTravel';

import { EventCommentsDocuments } from '@components/EventDrawer/EventDrawerUi/EventCommentsDocuments';
import { EventModelNameLineNonBooking } from '@components/EventDrawer/EventDrawerUi/EventModelNameLineNonBooking';
import { EventDetailsWrapper } from '@components/EventDrawer/EventDrawerUi/EventUI';
import NwEllipsis from '@components/Gui/NwEllipsis';
import ResponsiveFlexContainer from '@components/Gui/ResponsiveFlexContainer';

const ModelInfo = styled.div``;

const TravelModelDetails = ({
    afterRemove,
    afterUpdate,
    event,
    onEditModelEvent,
    onUpdateTravels,
    onTouchForm,
    openedEventID,
    plainMode,
}) => {
    const { mutateAsync: onDeleteTravel } = useDeleteTravel();

    const handleRemoveEvent = async () => {
        try {
            await onDeleteTravel({ ID: event.ID, travelId: openedEventID });
            onUpdateTravels();
        } catch (error) {
            console.error('Remove Event Date Model Error => ', error);
        }
    };

    const handleUnlinkEvent = async () => {
        try {
            await Axios.put(`/travels/UnLink/${event.ID}`);
            onUpdateTravels();
        } catch (error) {
            console.error('Unlink Event Error => ', error);
        }
    };

    const modelNameLineProps = {
        actions: {
            onEdit: onEditModelEvent,
            onDelete: async () => {
                await handleRemoveEvent();
                if (event.ID === openedEventID) {
                    afterRemove();
                } else {
                    onUpdateTravels();
                    afterUpdate();
                }
            },
            onUnlink: () => handleUnlinkEvent(),
            onAcknowledgmentUpdate: () => {
                onUpdateTravels();
                afterUpdate();
            },
            onCancelUpdate: () => {
                onUpdateTravels();
                afterUpdate();
            },
        },
        eventProperties: {
            eventType: 'Travel',
            isSingle: false,
            hasExport: true,
        },
        event: event,
    };

    return (
        <>
            <ModelInfo>
                <EventModelNameLineNonBooking {...modelNameLineProps} />
            </ModelInfo>
            <EventDetailsWrapper className={event.Cancel ? 'is-cancelled' : null}>
                <ResponsiveFlexContainer
                    leftMinWidth={180}
                    columns={[
                        {
                            content: <p className="is-label">Ticket Number</p>,
                            isBorder: true,
                        },
                        {
                            content: <p className="is-content">{event.TicketID}</p>,
                            isBorder: false,
                        },
                    ]}
                />
                <ResponsiveFlexContainer
                    leftMinWidth={180}
                    columns={[
                        {
                            content: <p className="is-label">Booking Reference</p>,
                            isBorder: true,
                        },
                        {
                            content: <p className="is-content">{event.BookingReference}</p>,
                            isBorder: false,
                        },
                    ]}
                />
                <ResponsiveFlexContainer
                    leftMinWidth={180}
                    columns={[
                        {
                            content: <p className="is-label">Flight/Train Code</p>,
                            isBorder: true,
                        },
                        {
                            content: <p className="is-content">{event.TransportReference}</p>,
                            isBorder: false,
                        },
                    ]}
                />
                <ResponsiveFlexContainer
                    leftMinWidth={180}
                    columns={[
                        {
                            content: <p className="is-label">Description</p>,
                            isBorder: true,
                        },
                        {
                            content: (
                                <div className="is-content small">
                                    <NwEllipsis rows={3} text={event.Description} />
                                </div>
                            ),
                            isBorder: false,
                        },
                    ]}
                />
            </EventDetailsWrapper>
            <EventCommentsDocuments
                event={event}
                api="TravelID"
                type="Travel"
                contactId={event.ModelID}
                drawerMode={!plainMode}
                fetchEvent={onUpdateTravels}
                disableTransaction={plainMode || !event.Project}
                onTransactionCreatedOrUpdated={onUpdateTravels}
                onTouchForm={onTouchForm}
            />
        </>
    );
};

export default TravelModelDetails;
